import { render, staticRenderFns } from "./CarryBags.vue?vue&type=template&id=5ca792f6&scoped=true&"
import script from "./CarryBags.vue?vue&type=script&lang=js&"
export * from "./CarryBags.vue?vue&type=script&lang=js&"
import style0 from "./CarryBags.vue?vue&type=style&index=0&id=5ca792f6&lang=scss&scoped=true&"
import style1 from "./CarryBags.vue?vue&type=style&index=1&id=5ca792f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca792f6",
  null
  
)

export default component.exports